import { render, staticRenderFns } from "./AndroidApp.vue?vue&type=template&id=7912e7f0"
import script from "./AndroidApp.vue?vue&type=script&lang=js"
export * from "./AndroidApp.vue?vue&type=script&lang=js"
import style0 from "./AndroidApp.vue?vue&type=style&index=0&id=7912e7f0&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports